import { useAppSelector } from "../../store/hooks";
import CoherencyReportScreen from "../reports/coherencyReport";

export default function SharedCoherencyScreen() {
  const session = useAppSelector(state => state.session);
  return (<div>
    {session.shared?.project ? <CoherencyReportScreen project={session.shared.project} /> : <p>You must have a project shared.</p>}
  </div>);
}
